module.exports = __webpack_public_path__ + "img/logo-azul.0611d204.png";